import { render, staticRenderFns } from "./PatientDiagnosisStatus.vue?vue&type=template&id=ba04c318&scoped=true&"
import script from "./PatientDiagnosisStatus.vue?vue&type=script&lang=js&"
export * from "./PatientDiagnosisStatus.vue?vue&type=script&lang=js&"
import style0 from "./PatientDiagnosisStatus.vue?vue&type=style&index=0&id=ba04c318&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba04c318",
  null
  
)

export default component.exports